export const FORM_IDS = {
  CREATE: "create-measurement-unit-form",
  EDIT: "edit-measurement-unit-form",
  DELETE: "delete-measurement-unit-form",
};
